import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import Collections from './Collection/Collections';
import MyCollections from './Collection/MyCollections';
//import CollectionDetail from './Collection/CollectionDetail';
//import ApiServices from '../services/ApiServices';

export const Home = () => {
    const [user, setUser] = useState();
    const [userHasCollections, setUserHasCollections] = useState(true);
    const [otherCollections, setOtherCollections] = useState(true);

    const history = useHistory();
    const detailRef = useRef(null);

   
    useEffect(() => {
        //selectCollection(null);

        const loggedInUser = localStorage.getItem("user");

        if (loggedInUser) {
            var currentUser = JSON.parse(loggedInUser)
            setUser(currentUser);
        }

        if (detailRef.current) {
            detailRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [])


    return (
        <div>
            <div className="headerHome">
                <img alt='plakplaatjesruilen.nl' src='/images/plakplaatjesruilen.png' />
                <p>Spaar hier mee aan supermarktacties en maak je plakboek compleet door met elkaar te ruilen.</p>
                {!user && (<><button className="btn btn_register" onClick={() => history.push('/register')}>Maak account</button>&nbsp;<button className="btn btn_login" onClick={() => history.push('/login')}>Inloggen</button></>)}
            </div>
            {(user && userHasCollections && <div><h2>Mijn collecties:</h2>
                <MyCollections isMyCollections={true}  key="mMyCollections" /></div>)}

            <br/>
            <br />
            <hr />
                <br />
                <br />

            {(otherCollections && <div><h2>Andere spaaracties:</h2>
            <Collections  isMyCollections={false} key="otherCollections"  /></div>)}

            {/*{selectedCollection != null && (*/}
            {/*    <div ref={detailRef} className="selectedCollectionDetails">*/}
            {/*        <CollectionDetail collection={selectedCollection} />*/}
            {/*        {!user && (<p>Meld je aan om mee te sparen.<br /><button className="btn btn_register" onClick={() => history.push('/register')}>Maak account</button>&nbsp;<button className="btn btn_login" onClick={() => history.push('/login')}>Inloggen</button></p>)}*/}

            {/*        {selectedCollection != null && !selectedCollection.isMyCollection && user && (<input type='button' className="btn" value='Voeg toe aan mijn collecties' onClick={() => AddToMyCollection(selectedCollection)} />)}*/}
            {/*    </div>)}*/}

        </div>
    );
}

export default Home;